module.exports = __webpack_public_path__ + "media/images/lb/758-f4a58e382346dd9cb7e3e61624f5b080.svg";